import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { reactLocalStorage } from 'reactjs-localstorage';
import Form from 'react-bootstrap/Form';
import AsyncSelect from 'react-select/async';

import MainSearchAPI from '../../api/MainSearchAPI';
import Display from '../../util/Display';

import Const from '../../util/Constants';
import ContactController from '../../controller/ContactController';
import FieldText from '../common/FieldText';
import FieldSelect from '../common/FieldSelect';
import FieldMultiPhone from '../common/FieldMultiPhone';
import FieldMultiValue from '../common/FieldMultiValue';

import Util from '../../util/Util';

class PropertyContactPopup extends React.Component {

  constructor(props) {
    super(props);

    const models = reactLocalStorage.getObject(Const.Model);
    this.model = models.contact;
    this.contact = ContactController.addModel(this.model.fields);
    this.contact.model_id = props.model_id;
    this.contact.model_no = props.model_no;
    this.contact.id = 0;
    this.state = { search: '',inValid: {}, selected: null, contact: { ...this.contact }};
    
    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const ContactRestrict = Util.isAllow(models.contact.permission, Const.PermRestricAcc);
   
    this.SearchBody = {};
    const field = 'responsible_person';
    const type = 'multiselect~user';
    const condition = 'in'; 
    const value = `~${[user.user_id, ...user.child].join('~')}~`;
    if(ContactRestrict) { this.SearchBody.contact = [{ field, type, condition, value }]; }
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props && props.contact && props.contact.id !== this.state.contact.id) {
      this.setState({ ...this.state, contact: { ...props.contact }});
    } else if(props.contact === null) { this.setState({ ...this.state, contact: { ...this.contact }}); }
  }

  onSearch = (text, callback) => {
    if (text.length > 2) {
      MainSearchAPI.list(text, this.SearchBody, res => {
        const contacts =  res.contacts ? res.contacts.map(contact =>
          { return { value: contact.id, label: Display.ModelName(contact) }; }) : [];
        callback(contacts);
      });
    }
    this.setState({ ...this.state, search: text })
  }

  onChange = selected => this.setState({ ...this.state, selected: selected });
  onHandleChange = event => this.setState({ ...this.state, checked: event.target.checked });
  
  onValueChange = (field, value) => {
    const contact = { ...this.state.contact };
    contact[field] = value;
    this.setState({ ...this.state, contact: { ...contact }});
  }

  quickSaveContact = () => {
    this.props.addContact({ id: 0, is_primary: this.state.checked, ...this.state.contact});
    //ContactAPI.quickSaveContact(this.state.contact, this.onSaved, this.props.failure);
    this.setState({ ...this.state, inApiCall: true });
  }

  onSaved = (res) => {
    Util.showNotification('Successful', 'Contact saved successfully', 'success');
    this.setState({ ...this.state, contact: { ...this.state.contact, id: res.id}, inApiCall: false });
    this.props.onHide();
    if(this.props.reload) {
      this.props.reload();
    }
  }

  render() {
    const fields = this.model.fields;
    const inValid = this.state.inValid;
    const contact = this.state.contact;
    return (
      <Modal aria-labelledby="contained-modal-title-vcenter" size="md" show={this.props.show}
        onHide={this.props.onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Existing Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <AsyncSelect cacheOptions isMulti={false} isClearable={true}
              loadOptions={this.onSearch} onChange={this.onChange} />
            <Form.Check onChange={this.onHandleChange} label="Is primary" />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.props.addContact({ id: this.state.selected.value, 
            is_primary: this.state.checked})} disabled={!this.state.selected}>
            Add Selected Contact
          </Button>
        </Modal.Footer>
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">Add New Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="col">
              <div className="form-group">
                <Form.Check onChange={this.onHandleChange} label="Is primary" />
              </div>
            </div>

            <FieldText key="firstname" id="firstname" field={fields.firstname}
              value={contact.firstname} onValueChange={this.onValueChange} inValid={inValid} />

            <FieldText key="lastname" id="lastname" field={fields.lastname}
              value={contact.lastname} onValueChange={this.onValueChange} inValid={inValid} />

            <FieldSelect key="contact_type" id="contact_type" field={fields.contact_type}
              value={contact.contact_type} onValueChange={this.onValueChange} inValid={inValid} />

            <FieldMultiPhone key="phone" id="phone" field={fields.phone}
              value={contact.phone} onValueChange={this.onValueChange} inValid={inValid} />

            <FieldMultiValue key="email" id="email" field={fields.email} value={contact.email}
              onValueChange={this.onValueChange} inValid={inValid} />

            <Button onClick={() => this.quickSaveContact()}>
              Add Contact
            </Button>

          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}
export default PropertyContactPopup;